export const getFullName = (
	first_name: string,
	last_name: string,
	patronymic: string
): string => {
	return [last_name || "", first_name || "", patronymic || ""].join(" ").trim();
};
